import * as React from 'react';
import { Card } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';
export function RegularHeader() {
    const t = useTranslation();
    return (React.createElement(Card.Header, { dataHook: "installed-apps-title", title: t('manage-apps.regular-apps.card-header.title') }));
}
//# sourceMappingURL=regular.apps-section-header.js.map